/**
 * Created by mvasim on 12/9/17.
 */

import { FnWeatherConstatnt } from './fn-weather.constant';
import { FnDeviceConstant } from './fn-device.constant';
import { FnDateFormatConstant } from './fn-date-format.constant';

/**
 * Class with readonly properties which are most commonly used in whole application to compare or to append or to replace.
 * OR to get read value if property is Map.
 */
export class FNConstant {
	/**
	 * property used for single space
	 */
	public static readonly SING_SPACE: string = ' ';
	/**
	 * property used for Empty String.
	 */
	public static readonly EMPTYSTR: string = '';
	/**
	 * property used for tilde Special Character.
	 */
	public static readonly TILDE: string = '~';
	/**
	 * property used for forward slash Special Character.
	 */
	public static readonly FWD_SLASH: string = '/';
	/**
	 * property used for comma Special Character.
	 */
	public static readonly COMMA: string = ',';
	/**
	 * used for Hyphen Special Character.
	 */
	public static readonly HYPHEN: string = '-';
	/**
	 * used for UNDERSCORE Special Character.
	 */
	public static readonly UNDERSCORE: string = '_';
	/**
	 * used for DOT Special Character.
	 */
	public static readonly DOT: string = '\\.';
	/**
	 * used for percentage Special Character.
	 */
	public static readonly PERC: string = '%';
	/**
	 * used for NO word.
	 */
	public static readonly NO: string = 'NO';
	/**
	 * used for null as string.
	 */
	public static readonly NULL_LC: string = 'null';
	/**
	 * used for undefined as value
	 */
	public static readonly UN_DEFINED: string = 'undefined';
	public static readonly FALSE_LC: string = 'false';
	public static readonly NULL: any = null;

	public static readonly WEATHER_ICON_HASH = FnWeatherConstatnt.WEATHER_ICONS;
	public static readonly WEATHER_STRINGS = FnWeatherConstatnt.WEATHER_STRINGS;
	public static readonly FNDEVICE_ICONS_HASH = FnDeviceConstant;
	// public static readonly FNINDEX_CONSTANT = FNIndexConstant;
	public static readonly FNDATE_FORMAT_MAP =
		FnDateFormatConstant.DATE_FORMAT_MAP;
	public static readonly FNTIME_FORMAT_MAP =
		FnDateFormatConstant.TIME_FORMAT_MAP;
	public static readonly NG_DATE_FORMAT_MAP =
		FnDateFormatConstant.NG_DATE_FORMAT_MAP;
	public static readonly NG_TIME_FORMAT_MAP =
		FnDateFormatConstant.NG_TIME_FORMAT_MAP;

	public static readonly COUNTRY_US = 'US';
	public static readonly COUNTRY_CA = 'CA';
}

// export const FULL_NAME_REGX = /^(?:[A-Za-z]+(?:\s+|$)){1,}$/;
// export const NAME_REGEX = /^[A-Za-z\s]*$/;
// export const CURRENCY_REGEX = /(\d)(?=(\d{3})+\.)/g;

export const FULL_NAME_REGX = new RegExp(/^(?:[A-Za-z]+(?:\s+|$)){1,}$/);
export const NAME_REGEX = new RegExp(/^[A-Za-z\s]*$/);
export const CURRENCY_REGEX = new RegExp(/(\d)(?=(\d{3})+\.)/g);
